import PuestoService from 'src/modules/puesto/puestoService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'PUESTO_VIEW';

const puestoViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: puestoViewActions.FIND_STARTED,
      });

      const record = await PuestoService.find(id);

      dispatch({
        type: puestoViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: puestoViewActions.FIND_ERROR,
      });

      getHistory().push('/puesto');
    }
  },
};

export default puestoViewActions;
